import {useStore} from "vuex";
import {useI18n} from "vue-i18n";
import moment from "moment";
import axios from "axios";

export function applyToStore(data, store) {
    Object.keys(data).forEach((key) => {
        if (typeof store._mutations[key] !== 'undefined') {
            store.commit(key, data[key]);
        }
    });
}

export function hexToRgb(hex, opacity) {
    hex = hex.replace('#','');
    return `rgba(${[parseInt(hex.substring(0,2), 16), parseInt(hex.substring(2,4), 16), parseInt(hex.substring(4,6), 16)].join(',')},${opacity/100})`;
}

export function getToRgbNumbers(hex) {
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
    }
    const num = parseInt(hex, 16);
    return `${(num >> 16) & 255},${(num >> 8) & 255},${num & 255}`;
}

export function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export function arrayMinMax(arr) {
    let min = Infinity;
    let max = -Infinity;
    for (let i = 0; i < arr.length; i++) {
        const v = +arr[i];
        if (v < min) min = v;
        if (v > max) max = v;
    }
    return { min, max };
}

export function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

export function secondsToTime(seconds)
{
    const store= useStore();
    const hours= Math.floor(seconds / (60 * 60));
    const divisorForMinutes= seconds % (60 * 60);
    const minutes= Math.floor(divisorForMinutes / 60);
    const divisorForSeconds= divisorForMinutes % 60;
    seconds = Math.ceil(divisorForSeconds);

    const durationForm = store.getters['settings/durationFormat'];
    switch (durationForm) {
        case 'hh:mm:ss':
            return `${('0' + hours).slice(-2)}:${('0' + minutes).slice(-2)}:${('0' + seconds).slice(-2)}`;
        default:
            return time_lrt(seconds, minutes, hours)
    }
}

export function time_lrt(seconds, minutes, hours) {
    const { t } = useI18n();
    if (hours < 0 || minutes < 0 || seconds < 0) return `0${t('front.second_short')}`;

    hours = hours ? `${hours}${t('front.hour_short')}`: '';
    minutes = minutes ? `${minutes}${t('front.minute_short')} `: '';
    seconds = hours ? `${hours}${t('front.second_short')}`: '';
    return `${hours} ${minutes} ${seconds}`;
}

export function onlyKeys(object, keys) {
    const result = {};
    Object.keys(object).forEach((key) => {
        if (keys.indexOf(key) === -1) return;
        result[key] = object[key];
    });
    return result;
}

export function placesRouteLatLngsToPointsString(a) {
    if (a.length <= 0) return '';

    var d = [];
    for (var c = 0; c < a.length; c++) {
        var f = a[c];
        var e = f.lat;
        var b = f.lng;
        d.push({lat: parseFloat(e).toFixed(6), lng: parseFloat(b).toFixed(6)});
    }
    return JSON.stringify(d);
}

export function uniqueId(length = 5) {
    const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = ' ';
    const charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
}

export function formDataToObject(formData) {
    const data = {};
    for (const [k, v] of formData.entries()) {
        let key = k;
        let value = v;
        if (key === '_method' || value === '' || value === null || typeof value === 'undefined') continue;
        if (key.match(/(\[\])$/)) {
            key = key.replace(/(\[\])$/, '');
            if (!data[key]) {
                data[key] = [];
            }
            data[key].push(value);
            continue;
        }

        data[key] = value;
    }
    return data;
}

export function googleMapUrl(lat, lng) {
    return `https://maps.google.com/maps?q=${lat},${lng}&t=m&hl=${window.setup.lang_locale}`;
}

export function parseDatepickerTemplate(tmp) {
    if (!tmp) return null;
    const { template } = tmp;
    const start = moment();
    const end = moment();
    switch (template) {
        case 'yesterday':
            start.subtract(1,'day');
            end.subtract(1, 'day');
            break;

        case 'before_2_days':
            start.subtract(2,'day');
            end.subtract(2, 'day');
            break;

        case 'before_3_days':
            start.subtract(3,'day');
            end.subtract(3, 'day');
            break;

        case 'this_week':
            start.startOf('week');
            end.endOf('week');
            break;

        case 'last_week':
            start.subtract(1, 'week').startOf('week');
            end.subtract(1, 'week').endOf('week');
            break;

        case 'this_month':
            start.startOf('month');
            end.endOf('month');
            break;

        case 'last_month':
            start.subtract(1, 'month').startOf('month');
            end.subtract(1, 'month').endOf('month');
            break;

    }

    return [start.format('YYYY-MM-DD 00:00:00'), end.format('YYYY-MM-DD 23:55:00')]
}

export function getFormLocalStorage(key, defaultValue) {
    if (typeof localStorage === 'undefined' || !localStorage) return defaultValue;
    const value = localStorage.getItem(key);
    return typeof value === 'undefined' || value === null ? defaultValue : value;
}

export function storeToLocalStorage(key, value) {
    try {
        if (typeof localStorage !== 'undefined' || !localStorage) {
            localStorage.setItem(key, value);
        }
    } catch (e) {
        console.warn("LocalStorage is not accessible:", e);
    }
}

export function removeFromLocalStorage(key) {
    try {
        if (typeof localStorage !== 'undefined' || !localStorage) {
            localStorage.removeItem(key);
        }
    } catch (e) {
        console.warn("LocalStorage is not accessible:", e);
    }
}

export function escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function settableItemTest(item, data) {
    item.testing = true;
    item.success = false;
    item.tested = false;
    item.error = null;

    axios.get(item.testUrl, { params: data || item.data }).then((response) => {
        item.success = true;
        item.error = null;
    }).catch((error) => {
        if (error?.response?.data?.message) {
            item.error = error?.response?.data?.message;
        }

        if(error.response?.data?.notify?.message) {
            item.error = error.response?.data?.notify?.message;
        }
    }).finally(() => {
        item.testing = false;
        item.tested = true;
    });
}

export function smoothScrollTo(container, target, duration = 500) {
    const start = container.scrollTop;
    const end = target.offsetTop;
    const change = end - start;
    const startTime = performance.now();

    function animateScroll(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1); // 0 → 1
        container.scrollTop = start + change * easeInOutQuad(progress);

        if (progress < 1) {
            requestAnimationFrame(animateScroll);
        }
    }

    // Easing function
    function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }

    requestAnimationFrame(animateScroll);
}